import { render, staticRenderFns } from "./AdminContentItemDateTable.vue?vue&type=template&id=57f369c6&scoped=true&"
import script from "./AdminContentItemDateTable.vue?vue&type=script&lang=ts&"
export * from "./AdminContentItemDateTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f369c6",
  null
  
)

export default component.exports
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QMarkupTable});
